export enum ActiveTxDateRange {
  lastMonth = 'lastMonth',
  past2to6Months = 'past2to6Months',
  past7to12Months = 'past7to12Months'
}
